import UAParser from "ua-parser-js";

export const getIsFirefox = () => navigator.userAgent.indexOf("Firefox") != -1;

export function getBrowserInfo() {
  return new UAParser().getResult();
}
